// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrAddressDto
 */
export interface IOcrAddressDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressDto
     */
    address_line_1?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressDto
     */
    address_line_2?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrAddressDto
     */
    zip?: string;
}

/**
 * Check if a given object implements the IOcrAddressDto interface.
 */
export function instanceOfIOcrAddressDto(value: object): value is IOcrAddressDto {
    return true;
}

export function IOcrAddressDtoFromJSON(json: any): IOcrAddressDto {
    return IOcrAddressDtoFromJSONTyped(json, false);
}

export function IOcrAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'address_line_1': json['address_line_1'] == null ? undefined : json['address_line_1'],
        'address_line_2': json['address_line_2'] == null ? undefined : json['address_line_2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
    };
}

export function IOcrAddressDtoToJSON(json: any): IOcrAddressDto {
    return IOcrAddressDtoToJSONTyped(json, false);
}

export function IOcrAddressDtoToJSONTyped(value?: IOcrAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address_line_1': value['address_line_1'],
        'address_line_2': value['address_line_2'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
    };
}

